import { useRouter } from "next/router";
import React from "react";
import CustomBtnComponent from "../btn/buttonCustom";

const ContactSection = () => {
  const router = useRouter();
  return (
    <div className="flex items-center flex-col space-y-[35px] py-12 md:py-20">
      {/* title  */}
      <div className="flex flex-col items-center">
        <h3 className="xsm:leading-[28px] md:leading-[56px] font-[590] text-[32px] md:text-[48px] text-[#010140] ">
          {router.locale == "en" ? "CONTACT US" : "اتصل بنا"}
        </h3>
        <hr className="bottomborder h-[5px] mt-1 md:mt-[11px] border-none rounded-[22.5px] w-[138px] "></hr>
      </div>

      <p className="text-[18px] text-[#010140] leading-[28px] text-center ">
        {router.locale == "en"
          ? "We Would Love To Hear From You"
          : "نسعد بتواصلكم معنا"}
        <br />
        {router.locale == "en"
          ? "Let's Make Something Awesome Together"
          : "نحن مستعدون لصنع أشياء رائعة من أجلكم!"}
      </p>

      <div className="flex justify-center items-center mx-auto mt-7 cursor-pointer w-fit ">
        <CustomBtnComponent
          txt={router.locale == "en" ? "CONTACT US" : "اتصل بنا"}
          href={"/contact"}
        />
      </div>
    </div>
  );
};

export default ContactSection;
